import styled from "styled-components";
import CardHeader from "./CardHeader";
import useStudentAttendance from "features/teacher/hooks/student/useStudentAttendance";
import PercentCircle from "shared/components/PercentCircle";
import { hw } from "features/homework/homeworkUi";

interface StudentAttendanceProps {
    studentUid: string;
}

const StudentAttendance = ({ studentUid }: StudentAttendanceProps) => {
    const { percent } = useStudentAttendance(studentUid);
    return (
        <Container>
            <CardHeader title="출결" color="#FFFFFF" />
            <Wrapper>
                <PercentCircle label="출석율" percent={percent} />
            </Wrapper>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-width: 0;
    padding: 18px 20px;
    border-radius: 16px;
    background: ${hw.brand};
    box-shadow: ${hw.shadow};
`;

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
`;

export default StudentAttendance;
